<template>

  <div class="content-i">
    <div class="content-box">
      <div class=" single-page-container">
        <div class="col-sm-6 col-md-3 pl-0 pr-0 middle middle">
          <SessionInfoBlock :mainUser="sessionInfoBlock.mainUser" :session="sessionInfoBlock.session" :totalProducts="products.length" :type="'retouchdesk'" />
        </div>
        <div class="col-sm-6 middle">
          <div class="support-index">
            <div class="support-tickets">
              <SessionTabs :tabOptions="tabOptions" :selectedTab="selectedTab" @sessionTabInterface="changeTab" />
              <ProductTab v-show="selectedTab == 'Products'" :products="productList" @productInterface="updateProductDetailsContainer" />
              <!-- <SessionOverview v-show="selectedTab == 'Overview'" :products="productList"/> -->
            </div>
          </div>
        </div>
        <div class="col-sm-3 col-md-3 middle pl-0">
          <SessionOverview :products="productList" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SessionTabs from '@/components/common/SessionView/SessionTabs'
import SessionInfoBlock from '@/components/common/SessionView/SessionInfoBlock'
import ProductTab from '@/components/pretouchdesk/ViewSession/ProductTab'
import ProductDetails from '@/components/photodesk/ViewSession/ProductDetails'
import SessionOverview from '@/components/photodesk/ViewSession/SessionOverview'
import EmptyState from '@/components/common/EmptyState'

export default {
  name: 'session-view',
  props: ['id_session'],
  components: {
    SessionTabs,
    SessionInfoBlock,
    ProductTab,
    ProductDetails,
    EmptyState,
    SessionOverview
  },
  mounted: function () {
    this.getSessionDetails()
  },
  data: function () {
    return {
      tabOptions: ['Products'],
      selectedTab: 'Products',
      photographer: [],
      vm: '',
      stylist: '',
      makeupartist: '',
      shootcoordinator: '',
      session: '',
      products: [],
      selectedProduct: '',
      loading: true
    }
  },
  computed: {
    productList () {
      return this.products
    },
    sessionInfoBlock () {
      return {
        mainUser: this.photographer,
        session: this.session
      }
    }
  },
  methods: {
    getSessionDetails: function () {
      var self = this
      self.$store.dispatch('updateLoading', 'true')

      const url = '/retouchdesk/session/show'
      let data = {
        id_retouchdesk_session: self.id_session
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.products = response.data.products
          self.photographer = response.data.photographer
          self.session = response.data.session
          self.$store.dispatch('updateLoading', 'false')
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateLoading', 'false')
        })
    },
    updateProductDetailsContainer: function (product) {
      this.selectedProduct = product
    },
    changeTab: function (tab) {
      this.selectedTab = tab
    },
    formatAvatar: function (user) {
      return 'background-image: url("http://52.66.102.131' + user.avatar + '")'
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  watch: {
    selectedProduct () {}
  }
}
</script>

<style>
.table th,
.table td {
  border: none;
}
.support-index {
  display: block !important;
}
</style>
